/* eslint-disable import/no-cycle */
export default [
  {
    path: '/goods-service',
    name: 'GoodsService',
    component: () => import('@/layouts/main.vue'),
    children: [
      {
        path: 'error-logs',
        name: 'GoodsServiceErrorLogs',
        component: () => import('@/views/goods-service/error-logs'),
        meta: {
          title: 'canal异常日志',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'goods-list',
        name: 'GoodsServiceGoodsList',
        component: () => import('@/views/goods-service/goods-list'),
        meta: {
          title: '商品信息',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'es-goods-list',
        name: 'EsGoodsServiceGoodsList',
        component: () => import('@/views/goods-service/es-goods-list'),
        meta: {
          title: 'ES商品信息',
          noCache: false,
          auth: true,
        },
      },
    ],
  },
];
